import React from 'react';

import { translate } from '~l10n/client';

import { UIButton } from '~shared/components/buttons';
import { DialogConfirmation, DialogProps } from '~shared/components/Dialog';

export interface Props extends Pick<DialogProps, 'open' | 'onClose'> {
  onConfirmClick: () => void;
}

export function ActivityFinishConfirmModal({
  open,
  onClose,
  onConfirmClick,
}: Props) {
  const [isFinishButtonDisabled, setIsFinishButtonDisabled] =
    React.useState(false);
  return (
    <DialogConfirmation
      id="confirm-finish-activity"
      open={open}
      title={translate('Finish Activity?')}
      onClose={onClose}
      closeLabel={translate('Close')}
      actions={[
        <UIButton
          appearance="primary"
          onClick={() => {
            setIsFinishButtonDisabled(true);
            onConfirmClick();
          }}
          isDisabled={isFinishButtonDisabled}
          key="primary"
        >
          {translate('Finish')}
        </UIButton>,
        <UIButton onClick={onClose} key="cancel">
          {translate('Cancel')}
        </UIButton>,
      ]}
    >
      {translate('This will end responses to the current activity.')}
    </DialogConfirmation>
  );
}
